export default __webpack_public_path__ + "static/media/all.72164e47.jpeg";